import { Deal } from 'app/models/dto/deal.model';

export class GetDealQuestionRequirements {
	static readonly type = '[DealApplicationRequirements] GetDealQuestionRequirements';
	constructor(public deal: Deal, public refresh?: boolean) {}
}

export class ClearApplicationRequirements {
	static readonly type = '[DealApplicationRequirements] ClearApplicationRequirements';
	constructor() {}
}

export class UpdateAnswers {
	static readonly type = '[DealApplicationRequirements] UpdateAnswers';
	constructor(public deal: Deal, public updatedFields: any) {}
}
